import { Document, Packer, Paragraph, TextRun, Table, TableCell, TableRow, WidthType, AlignmentType } from 'docx';

/**
 * Generate báo cáo đề nghị sản xuất biển số xe - Hỗ trợ nhiều seri
 * @param {Object} data - Dữ liệu báo cáo
 * @param {string} data.unitName - Tên đơn vị
 * @param {Array} data.seriesGroups - Mảng các nhóm seri [{provinceCode, series, plates, color, unitType}, ...]
 * @returns {Promise<{blob: Blob, fileName: string}>}
 */
export const generateMultiSeriesReport = async (data) => {
  const { unitName, seriesGroups } = data;
  
  const now = new Date();
  const day = now.getDate();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  
  const children = [
    // Header
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: 'none', size: 0 },
        bottom: { style: 'none', size: 0 },
        left: { style: 'none', size: 0 },
        right: { style: 'none', size: 0 },
        insideHorizontal: { style: 'none', size: 0 },
        insideVertical: { style: 'none', size: 0 }
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'CÔNG AN TỈNH LÂM ĐỒNG', bold: false, size: 26 })],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [new TextRun({ text: `CÔNG AN ${unitName}`, bold: true, size: 26, underline: {} })],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }
                }),
                new Paragraph({
                  children: [
                    new TextRun({ text: 'Số: ', size: 26 }),
                    new TextRun({ text: '/CAP', size: 26 })
                  ],
                  alignment: AlignmentType.LEFT,
                  spacing: { after: 100 }
                }),
                new Paragraph({
                  children: [new TextRun({ text: 'V/v đặt hàng sản xuất biển số xe phản quang', italics: true, size: 26 })],
                  alignment: AlignmentType.LEFT
                })
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
              borders: { top: { style: 'none' }, bottom: { style: 'none' }, left: { style: 'none' }, right: { style: 'none' } }
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM', bold: true, size: 26 })],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [new TextRun({ text: 'Độc lập - Tự do - Hạnh phúc', bold: true, size: 26, underline: {} })],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 200 }
                }),
                new Paragraph({
                  children: [new TextRun({ text: `${unitName}, ngày ${day} tháng ${month} năm ${year}`, italics: true, size: 26 })],
                  alignment: AlignmentType.CENTER
                })
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
              borders: { top: { style: 'none' }, bottom: { style: 'none' }, left: { style: 'none' }, right: { style: 'none' } }
            })
          ]
        })
      ]
    }),
    
    new Paragraph({ text: '', spacing: { after: 400 } }),
    
    new Paragraph({
      children: [new TextRun({ text: 'Kính gửi: Phòng PC08 Công an tỉnh Lâm Đồng', bold: true, size: 26 })],
      alignment: AlignmentType.CENTER,
      spacing: { after: 300 }
    }),
    
    new Paragraph({
      children: [new TextRun({ text: 'Căn cứ theo dõi số lượng phương tiện đăng ký thực tế sử dụng tại đơn vị;', size: 26 })],
      spacing: { after: 200 }
    }),
    
    new Paragraph({
      children: [new TextRun({ text: `Công an ${unitName} đề nghị Phòng PC08 Công an tỉnh Lâm Đồng tập hợp đề nghị sản xuất biển số xe cơ giới như sau:`, size: 26 })],
      spacing: { after: 400 }
    }),
    
    new Paragraph({
      children: [new TextRun({ text: 'I. MÔ TÔ', bold: true, size: 26 })],
      spacing: { after: 200 }
    }),
    
    new Paragraph({
      children: [new TextRun({ text: '1. Seri', bold: true, size: 26 })],
      spacing: { after: 200 }
    })
  ];
  
  // Tạo 1 bảng duy nhất chứa tất cả các seri (mỗi seri 1 dòng)
  const tableRows = [
    // Header row
    new TableRow({
      children: [
        new TableCell({ children: [new Paragraph({ text: 'Đơn vị', alignment: AlignmentType.CENTER })], width: { size: 15, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'Đầu biển theo tỉnh', alignment: AlignmentType.CENTER })], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'Seri', alignment: AlignmentType.CENTER })], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'Biển số', alignment: AlignmentType.CENTER })], width: { size: 45, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'Nền', alignment: AlignmentType.CENTER })], width: { size: 8, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'SL', alignment: AlignmentType.CENTER })], width: { size: 6, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph({ text: 'ĐV', alignment: AlignmentType.CENTER })], width: { size: 6, type: WidthType.PERCENTAGE } })
      ]
    })
  ];
  
  let totalPlates = 0;
  
  // Thêm 1 dòng cho mỗi seri
  seriesGroups.forEach((group) => {
    const numbers = group.plates.map(p => {
      const match = p.fullPlate.match(/\d{3}\.\d{2}/);
      return match ? match[0] : '';
    }).filter(n => n);
    
    const platesList = numbers.join('; ');
    totalPlates += group.plates.length;
    
    tableRows.push(
      new TableRow({
        children: [
          new TableCell({ children: [new Paragraph({ text: unitName, alignment: AlignmentType.CENTER })] }),
          new TableCell({ children: [new Paragraph({ text: group.provinceCode, alignment: AlignmentType.CENTER })] }),
          new TableCell({ children: [new Paragraph({ text: group.series, alignment: AlignmentType.CENTER })] }),
          new TableCell({ children: [new Paragraph({ text: platesList })] }),
          new TableCell({ children: [new Paragraph({ text: group.color, alignment: AlignmentType.CENTER })] }),
          new TableCell({ children: [new Paragraph({ text: group.plates.length.toString(), alignment: AlignmentType.CENTER })] }),
          new TableCell({ children: [new Paragraph({ text: group.unitType, alignment: AlignmentType.CENTER })] })
        ]
      })
    );
  });
  
  // Dòng tổng
  tableRows.push(
    new TableRow({
      children: [
        new TableCell({ children: [new Paragraph({ text: 'TỔNG', alignment: AlignmentType.CENTER, bold: true })], columnSpan: 5 }),
        new TableCell({ children: [new Paragraph({ text: totalPlates.toString(), alignment: AlignmentType.CENTER, bold: true })] }),
        new TableCell({ children: [new Paragraph({ text: '', alignment: AlignmentType.CENTER })] })
      ]
    })
  );
  
  children.push(
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: tableRows
    })
  );
  
  // Kết luận
  children.push(
    new Paragraph({
      children: [new TextRun({ text: 'Kính đề xuất các đồng chí quan tâm sản xuất biển số xe trên kịp thời./.', size: 26 })],
      spacing: { before: 400, after: 600 }
    }),
    
    // Chữ ký
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: 'none' }, bottom: { style: 'none' }, left: { style: 'none' }, right: { style: 'none' },
        insideHorizontal: { style: 'none' }, insideVertical: { style: 'none' }
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({ children: [new TextRun({ text: 'Nơi nhận:', bold: true, size: 24 })] }),
                new Paragraph({ children: [new TextRun({ text: '- Như trên;', size: 24 })] }),
                new Paragraph({ children: [new TextRun({ text: '- Lưu: CAP.', size: 24 })] })
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
              borders: { top: { style: 'none' }, bottom: { style: 'none' }, left: { style: 'none' }, right: { style: 'none' } }
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'P. TRƯỞNG CÔNG AN', bold: true, size: 26 })],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({ text: '', spacing: { after: 1200 } })
              ],
              width: { size: 50, type: WidthType.PERCENTAGE },
              borders: { top: { style: 'none' }, bottom: { style: 'none' }, left: { style: 'none' }, right: { style: 'none' } }
            })
          ]
        })
      ]
    })
  );
  
  const doc = new Document({
    sections: [{ properties: {}, children }]
  });
  
  const blob = await Packer.toBlob(doc);
  const filename = `Báo cáo CSGT - ${unitName} - ${Date.now()}.docx`;
  
  return { blob, filename };
};
